import {
    Award,
    GraduationCap,
    Heart,
    PlayCircle,
    Users,
    Sparkles,
    ArrowRight,
} from "lucide-react";

export default function HumanityRisingSection() {
    const benefits = [
        {
            icon: Award,
            label: "Earn service-learning hours",
            color: "bg-violet-500",
        },
        {
            icon: GraduationCap,
            label: "Be eligible for scholarships",
            color: "bg-rose-500",
        },
        {
            icon: Heart,
            label: "Share your story and inspire others",
            color: "bg-sky-500",
        },
        {
            icon: PlayCircle,
            label: "Be featured as a REEL Changemaker",
            color: "bg-amber-500",
        },
        {
            icon: Users,
            label: "Connect with other students creating impact",
            color: "bg-lime-500",
        },
    ];

    return (
        <section
            className="bg-[#f6f0df] px-4 py-7"
            style={{
                fontFamily: "'Bangers', 'Nunito Sans', sans-serif",
            }}
        >
            <div className="mx-auto max-w-[1120px] overflow-hidden rounded-[16px] border-[4px] border-black bg-[#f8f1df] shadow-[5px_5px_0_#000]">
                <div className="grid lg:grid-cols-[1.08fr_0.92fr]">
                    {/* LEFT PANEL */}
                    <div className="border-b-[4px] border-black bg-[linear-gradient(180deg,#6f2dbd_0%,#5f22a8_100%)] px-5 py-4 text-white lg:border-b-0 lg:border-r-[4px]">
                        <h2 className="text-[1.8rem] leading-[0.88] text-white drop-shadow-[2px_2px_0_#000] sm:text-[2.3rem]">
                            TAKE IT FURTHER WITH
                        </h2>

                        <div className="ml-8 mt-1 text-[2rem] leading-[0.88] text-[#ffd227] drop-shadow-[2px_2px_0_#000] sm:text-[2.9rem] tracking-widest">
                            HUMANITY RISING
                        </div>

                        <div
                            className="mt-4 space-y-2"
                            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
                        >
                            <p className="text-[1rem] font-black leading-tight text-white sm:text-[1.15rem]">
                                Call It Out is just the beginning.
                            </p>
                            <p className="text-[1.2rem] font-black italic leading-tight text-[#ffe534] sm:text-[1.4rem]">
                                TAKE THE CALL IT OUT CHALLENGE.
                            </p>
                            <p className="text-[1rem] font-extrabold leading-snug text-white sm:text-[1.08rem]">
                                Play the game, start conversations, and share your story to inspire others.
                            </p>
                        </div>

                        <div className="mt-4 flex gap-3 rounded-[16px] border-[4px] border-black bg-[#f7f1e8] p-3 text-black shadow-[4px_4px_0_#000]">
                            <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-[3px] border-black bg-violet-500 text-white shadow-[2px_2px_0_#000]">
                                <Award className="h-5 w-5" strokeWidth={2.5} />
                            </div>

                            <p
                                className="text-[0.95rem] leading-snug sm:text-[1rem]"
                                style={{ fontFamily: "'Nunito Sans', sans-serif" }}
                            >
                                Join Humanity Rising, a student-led movement empowering young people to become upstanders, strengthen their mental well-being, and create cultures of kindness and respect in their schools and communities.
                            </p>
                        </div>
                    </div>

                    {/* RIGHT PANEL */}
                    <div className="relative h-[380px] overflow-hidden bg-sky-300 lg:h-[380px]">
                        <img
                            src="/assets/InCity.png"
                            alt="Humanity Rising students"
                            className="h-full w-full object-cover object-top"
                        />

                        <div className="absolute right-3 top-3  rotate-[-4deg] rounded-[999px] border-[4px] border-black bg-[#ffd400] px-8 py-3 text-center text-[1rem] leading-[0.95] text-black shadow-[4px_4px_0_#000] sm:text-[1.6rem] tracking-wide">
                            BE AN UPSTANDER. CREATE CHANGE.
                        </div>
                    </div>
                </div>

                {/* BENEFITS BAR */}
                <div className="border-t-[4px] border-black bg-[#ffd227] px-4 py-1.5 text-center text-[1.1rem] tracking-wider leading-none text-black sm:text-[1.4rem]">
                    BY PARTICIPATING IN THE CALL IT OUT CHALLENGE, YOU CAN:
                </div>

                <div className="grid gap-0 border-t-[4px] border-black bg-[#f8f4ea] sm:grid-cols-2 lg:grid-cols-5">
                    {benefits.map((item, index) => {
                        const Icon = item.icon;

                        return (
                            <div
                                key={item.label}
                                className={`flex items-center gap-2 px-3 py-3 ${
                                    index !== benefits.length - 1
                                        ? "border-b-[3px] border-black lg:border-b-0 lg:border-r-[3px]"
                                        : ""
                                }`}
                            >
                                <div
                                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-[3px] border-black text-white shadow-[2px_2px_0_#000] ${item.color}`}
                                >
                                    <Icon className="h-5 w-5" strokeWidth={2.5} />
                                </div>

                                <p
                                    className="whitespace-pre-line text-[1rem] font-bold leading-tight text-black"
                                    style={{ fontFamily: "'Nunito Sans', sans-serif" }}
                                >
                                    {item.label}
                                </p>
                            </div>
                        );
                    })}
                </div>

                {/* CTA */}
                <div className="flex justify-center px-4 py-4">
                    <a
                        href="https://humanityrising.org/2026-rise-up-challenge/" target="_blank" rel="noreferrer" 
                        className="group inline-flex items-center gap-2 rounded-[16px] border-[4px] border-black bg-[#ff3855] px-5 py-2.5 text-center text-[1.5rem] leading-none text-white shadow-[4px_4px_0_#000] transition-transform duration-200 hover:-translate-y-1 tracking-wider"
                    >
                        <Sparkles className="h-5 w-5 text-yellow-300" strokeWidth={2.5} />
                        <span>JOIN THE MOVEMENT HERE</span>
                        <ArrowRight
                            className="h-5 w-5 text-yellow-300 transition-transform group-hover:translate-x-1"
                            strokeWidth={2.5}
                        />
                    </a>
                </div>
            </div>
        </section>
    );
}